export default __webpack_public_path__ + "static/media/package-icon-vehicle.8b5c0677.svg";